import { trackClientEvent } from '../../../../trackClientEvent';
export var eventKey = 'retailers-retailer_select_custom_option-click';
/**
 * This event will fire when user select and complete a custom option from dropdown
 */ export function trackRetailersRetailerSelectCustomOptionClick(custom_option) {
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: false,
        parameters: {
            custom_option: custom_option
        }
    });
}
